import React from 'react'
import './content-home.scss'
import logoUniversoCole from '../../../assets/images/content-home/logoHomeUniversoCole.png'
import logoUniversoColeMB from '../../../assets/images/content-home/logoHomeUniversoColeMB.png'
import logoInfoAdicional from '../../../assets/images/content-home/logoHomeInfoAdicional.svg'
import formaInfoAdicional from '../../../assets/images/content-home/formaInfoAdicionalHome.svg'
//realizando pruebas de cual carga mas rapido si apng o gif
// import animacion_planetas from '../../../assets/images/content-home/animacion-planetas.png'
//import animacion_planetas from '../../../assets/images/content-home/test.gif'

import useMediaQuery from '../../../utils/useMediaQuery'
import Button from '../../atoms/button/button'

import { jsonToHash } from '../../../utils/crypto'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import { navigate } from 'gatsby'
import AnimationPlanets from '../../atoms/animation-planets/animation-planets'
import { ImageByRegion1, text1, text2, text3, textMobile1 } from './text-content-home'

const ContentHome = () => {
  const isMobile = useMediaQuery()
  const userInfo = getUserInfo()

  const handleClick = async evt => {
    if (evt) {
      let text = evt.target?.innerText
      if (text) {
        if (text) {
          pushEventData({
            event: 'Interacciones_Home_UCole',
            label: text,
            user_data: userInfo && [
              await jsonToHash({
                nombre: userInfo.name,
                apellido: userInfo.lastName,
                celular: userInfo.cellPhone,
                correo: userInfo.email,
                ciudad: userInfo.location.cityName,
                departamento: userInfo.location.countryStateName,
                pais: userInfo.countryName,
              }),
            ],
            log_status: userInfo ? 'Yes' : 'Not',
          })
        }
      }
    }
    navigate('jugar')
  }

  return (
    <div className="f-contentHomeUniverse">
      <div className="f-contentHomeUniverse__left">
        {!isMobile && (
          <>
            <div className="f-contentHomeUniverse__left__title">
              <h2>En esta experiencia,</h2>
              <span className="f-contentHomeUniverse__left__title__spanTitle">
                {text2}
              </span>
            </div>
            <div className="f-contentHomeUniverse__left__text">
              {text3}
            </div>
          </>
        )}
        <div className="f-contentHomeUniverse__left__infoAdicional">
          <img
            src={logoInfoAdicional}
            alt=""
            className="f-contentHomeUniverse__left__infoAdicional__imgText"
          />
          <div className="f-contentHomeUniverse__left__infoAdicional__contentInfo">
            <p className="f-contentHomeUniverse__left__infoAdicional__contentInfo__title">
              ¡Serán 2 fases!
            </p>
            <img src={formaInfoAdicional} alt="" />
            <p className="f-contentHomeUniverse__left__infoAdicional__contentInfo__text">
              {text1}
            </p>
          </div>
        </div>
        {isMobile && (
          <ImageByRegion1 isMobile = {isMobile}/>
        )}
      </div>
      <div className="f-contentHomeUniverse__center">
        <img
          className="f-contentHomeUniverse__center__logoUniverso"
          src={isMobile ? logoUniversoColeMB : logoUniversoCole}
          alt=""
        />
        {isMobile ? (
          <>
            <div className="f-contentHomeUniverse__left__title">
              <h2>En esta experiencia,</h2>
              <span className="f-contentHomeUniverse__left__title__spanTitle">
                {text2}
              </span>
            </div>
            <div className="f-contentHomeUniverse__left__text">
              <p>
                {textMobile1}
              </p>
            </div>
          </>
        ) : (
          <ImageByRegion1 isMobile = {isMobile}/>
        )}
      </div>
      <div className="f-contentHomeUniverse__right">
        {/* <img
          src={animacion_planetas}
          alt="animacion de planetas en movimientos"
          className="f-contentHomeUniverse__right__animacionPlanetas"
        /> */}
        <AnimationPlanets className="f-contentHomeUniverse__right__animacionPlanetas" />
        <Button className="f-buttonHome" onClick={handleClick}>
          ¡Quiero jugar ya!
        </Button>
      </div>
    </div>
  )
}

export default ContentHome
